<template>
    <div>
        <div v-if="getHistory.length">
            <div v-for="item in getHistory" class="history-item">
                <div @click="clickHandler" class="history-item__top">
                    <div class="history-item__date">
                        {{ getDate(item.created) }}
                    </div>
                    <div class="history-item__author">
                        {{ item.created_by_name }}
                    </div>
                    <div class="history-item__type">
                        {{ item.type }}
                    </div>
                    <div class="history-item__name">
                        {{ item.new_data.language_versions[0].header }}
                    </div>
                    <div class="history-item__toggle">
                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.29614 1L5.29614 5L9.29614 1" stroke="#0A467E" stroke-linecap="round"/>
                        </svg>
                    </div>
                </div>
                <div class="history-item__body-wrapper">
                    <div class="history-item__body">
                    <div class="history-item__cells">
                        <div class="history-item__cell">
                            <div class="history-item__cell-caption">Период:</div>
                            <div class="history-item__cell-content">
                                <p class="history-item__value">
                                    {{ getDatePeriod(item.new_data.begin_date, item.new_data.end_date) }}
                                </p>
                                <template v-if="item.old_data">
                                    <p v-if="compareValues(getDatePeriod(item.new_data.begin_date, item.new_data.end_date), getDatePeriod(item.old_data.begin_date, item.old_data.end_date))" class="history-item__value_old">
                                        {{ getDatePeriod(item.old_data.begin_date, item.old_data.end_date) }}
                                    </p>
                                </template>
                            </div>
                        </div>
                        <div class="history-item__cell">
                            <div class="history-item__cell-caption">Видимость:</div>
                            <div class="history-item__cell-content">
                                <p class="history-item__value">
                                    {{ item.new_data.available[0].name }}
                                </p>
                                <template v-if="item.old_data">
                                    <p v-if="item.old_data.available.length > 0 && compareValues(item.new_data.available[0].name, item.old_data.available[0].name)" class="history-item__value_old">
                                        {{ item.old_data.available[0].name }}
                                    </p>
                                </template>
                            </div>
                        </div>
                        <div class="history-item__cell">
                            <div class="history-item__cell-caption">Тег:</div>
                            <div class="history-item__cell-content">
                                <p class="history-item__value">
                                    {{ getTagName(item.new_data.tag) }}
                                </p>
                                <template v-if="item.old_data">
                                    <p v-if="item.old_data.tag && compareValues(getTagName(item.new_data.tag), getTagName(item.old_data.tag))" class="history-item__value_old">
                                        {{ getTagName(item.old_data.tag) }}
                                    </p>
                                </template>
                            </div>
                        </div>
                        <div class="history-item__cell">
                            <div class="history-item__cell-caption">Вендор:</div>
                            <div class="history-item__cell-content">
                                <p class="history-item__value">
                                    {{ getVendorName(item.new_data.vendor) }}
                                </p>
                                <template v-if="item.old_data">
                                    <p v-if="item.old_data.vendor && compareValues(getVendorName(item.new_data.vendor), getVendorName(item.old_data.vendor))" class="history-item__value_old">
                                        {{ getVendorName(item.old_data.vendor) }}
                                    </p>
                                </template>
                            </div>
                        </div>
                        <div class="history-item__cell">
                            <div class="history-item__cell-caption">Просмотры:</div>
                            <div class="history-item__cell-content">
                                <p class="history-item__value">
                                    {{ item.new_data.views }}
                                </p>
                                <template v-if="item.old_data">
                                    <p v-if="item.old_data.views && compareValues(item.new_data.views, item.old_data.views)" class="history-item__value_old">
                                        {{ item.old_data.views }}
                                    </p>
                                </template>
                            </div>
                        </div>
                        <div class="history-item__cell">
                            <div class="history-item__cell-caption">Линк:</div>
                            <div class="history-item__cell-content">
                                <p class="history-item__value">
                                    <a target="_blank" :href="item.link">{{ item.new_data.link }}</a>
                                </p>
                                <template v-if="item.old_data">
                                    <p v-if="item.old_data.link && compareValues(item.new_data.link, item.old_data.link)" class="history-item__value_old">
                                        <a target="_blank" :href="item.old_data.link">{{ item.old_data.link }}</a>
                                    </p>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="history-item__langs">
                        <div class="history-item__lang history-lang">
                            <div class="history-lang__caption">
                                {{getLanguageName(item.new_data.platform, item.new_data.language_versions[0].language)}}-версия
                            </div>
                            <div class="history-lang__row">
                                <div class="history-lang__field">Заголовок</div>
                                <div class="history-lang__values">
                                    <p class="history-item__value">{{item.new_data.language_versions[0].header}}</p>
                                    <template v-if="item.old_data">
                                        <p v-if="item.old_data.language_versions[0].header && compareValues(item.new_data.language_versions[0].header, item.old_data.language_versions[0].header)" class="history-item__value_old">
                                            {{item.old_data.language_versions[0].header}}
                                        </p>
                                    </template>
                                </div>
                            </div>
                            <div class="history-lang__row">
                                <div class="history-lang__field">Текст</div>
                                <div class="history-lang__values">
                                    <p class="history-item__value">{{item.new_data.language_versions[0].additional_text}}</p>
                                    <template v-if="item.old_data">
                                        <p v-if="item.old_data.language_versions[0].additional_text && compareValues(item.new_data.language_versions[0].additional_text, item.old_data.language_versions[0].additional_text)" class="history-item__value_old">
                                            {{item.old_data.language_versions[0].additional_text}}
                                        </p>
                                    </template>
                                </div>
                            </div>
                            <div class="history-lang__row">
                                <div class="history-lang__field">Кнопка</div>
                                <div class="history-lang__values">
                                    <p class="history-item__value">{{item.new_data.language_versions[0].button_text}}</p>
                                    <template v-if="item.old_data">
                                        <p v-if="item.old_data.language_versions[0].button_text && compareValues(item.new_data.language_versions[0].button_text, item.old_data.language_versions[0].button_text)" class="history-item__value_old">
                                            {{item.old_data.language_versions[0].button_text}}
                                        </p>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="history-item__lang history-lang">
                            <div class="history-lang__caption">
                                {{getLanguageName(item.new_data.platform, item.new_data.language_versions[1].language)}}-версия
                            </div>
                            <div class="history-lang__row">
                                <div class="history-lang__field">Заголовок</div>
                                <div class="history-lang__values">
                                    <p class="history-item__value">{{item.new_data.language_versions[1].header}}</p>
                                    <template v-if="item.old_data">
                                        <p v-if="item.old_data.language_versions[1].header && compareValues(item.new_data.language_versions[1].header, item.old_data.language_versions[1].header)" class="history-item__value_old">
                                            {{item.old_data.language_versions[1].header}}
                                        </p>
                                    </template>
                                </div>
                            </div>
                            <div class="history-lang__row">
                                <div class="history-lang__field">Текст</div>
                                <div class="history-lang__values">
                                    <p class="history-item__value">{{item.new_data.language_versions[1].additional_text}}</p>
                                    <template v-if="item.old_data">
                                        <p v-if="item.old_data.language_versions[1].additional_text && compareValues(item.new_data.language_versions[1].additional_text, item.old_data.language_versions[1].additional_text)" class="history-item__value_old">
                                            {{item.old_data.language_versions[1].additional_text}}
                                        </p>
                                    </template>
                                </div>
                            </div>
                            <div class="history-lang__row">
                                <div class="history-lang__field">Кнопка</div>
                                <div class="history-lang__values">
                                    <p class="history-item__value">{{item.new_data.language_versions[1].button_text}}</p>
                                    <template v-if="item.old_data">
                                        <p v-if="item.old_data.language_versions[1].button_text && compareValues(item.new_data.language_versions[1].button_text, item.old_data.language_versions[1].button_text)" class="history-item__value_old">
                                            {{item.old_data.language_versions[1].button_text}}
                                        </p>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div v-else-if="$parent.isBoss">
            <p>История грузится</p>
        </div>
        <div v-if="!$parent.isBoss">
            <p>У вас нет доступа для просмотра данной страницы</p>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import moment from "moment";
    export default {
        name: "History",
        data() {
            return {
                opened: false
            }
        },
        computed: {
            ...mapGetters(['getHistory', 'getTags', 'getVendors', 'getLanguages']),
        },
        async created() {
            await this.$store.dispatch('get_history');
        },
        methods: {
            getDate(dateString) {
                return moment(dateString).format("DD.MM.YYYY, HH:mm:ss")
            },
            getDatePeriod(start, end) {
                if (start && end)
                    return moment(start, "YYYY-MM-DD").format("DD.MM.YYYY") + ' - ' + moment(end, "YYYY-MM-DD").format("DD.MM.YYYY");
                else
                    return false;
            },
            compareValues(value, oldValue) {
                return oldValue && oldValue !== "None" && value !== oldValue;
            },

            getTagName(id) {
                for (const tag of this.getTags) {
                    if (tag.id === parseInt(id)) {
                        return tag.tagName;
                    }
                }
            },
            getVendorName(id) {
                for (const vendor of this.getVendors) {
                    if (vendor.id === parseInt(id)) {
                        return vendor.vendorName;
                    }
                }
            },
            getLanguageName(platform, id) {
                for (const language of this.getLanguages[platform]) {
                    if (language.id === parseInt(id)) {
                        return language.short_name;
                    }
                }
            },
            getLanguage(item, typeData, id) {
                for (let lang in item[typeData].language_versions) if (item[typeData].language_versions.hasOwnProperty(lang)) {
                    if (lang.language == id) {
                        return lang;
                    }
                }
            },
            getFirstLang(item) {
                if (item.new_data.language_versions[0].language < item.new_data.language_versions[1].language) {
                    return item.new_data.language_versions[0].language;
                } else {
                    return item.new_data.language_versions[1].language;
                }
            },
            clickHandler(event) {
                const target = event.target.closest('.history-item');

                if (this.opened) {
                    this.opened.classList.remove('history-item_opened');
                    this.opened.querySelector('.history-item__body-wrapper').style.height = 0;
                }

                if (this.opened === target) {
                    this.opened = false;
                    return;
                }

                this.opened = target;
                this.opened.classList.add("history-item_opened");
                const height = this.opened.querySelector('.history-item__body').offsetHeight;
                this.opened.querySelector('.history-item__body-wrapper').style.height = height + 'px';


            }
        }
    }

</script>

<style scoped>
    .history-item {
        border-bottom: 1px solid #E6E6E6;
    }
    .history-item__top {
        padding: 20px 30px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 15px;
        color: #232323;
        cursor: pointer;
        transition: .3s;
    }

    .history-item_opened .history-item__top {
        background-color: #F1F7FC;
    }

    .history-item__date {
        width: 150px;
        flex-shrink: 0;
    }

    .history-item__author {
        width: 235px;
        flex-shrink: 0;
        text-align: center;
        font-weight: bold;
    }

    .history-item__type {
        width: 130px;
        text-align: center;
    }

    .history-item__name {
        width: 500px;
    }

    .history-item__toggle {
        margin-left: auto;
    }

    .history-item__toggle svg {
        transform: rotate(0);
        transition: .3s;
    }

    .history-item_opened .history-item__toggle svg {
        transform: rotate(180deg);
    }

    .history-item__body {
        padding: 20px 30px;
    }

    .history-item__cells {
        margin-bottom: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .history-item__cell {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin-left: 38px;
    }

    .history-item__cell:first-child {
        margin-left: 0;
    }

    .history-item__cell-caption {
        margin-right: 8px;
        font-size: 15px;
        line-height: 19px;
        color: #232323;
        font-weight: bold;
    }

    .history-item__value {
        font-size: 15px;
        line-height: 19px;
        color: #56565A;
    }

    .history-item__value_old {
        font-size: 15px;
        line-height: 19px;
        text-decoration-line: line-through;
        color: #525252;
        opacity: .5;
    }

    .history-item__value a,
    .history-item__value_old a{
        color: #0B78C7;
        max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-decoration: none;
    }

    .history-item__value_old a {
        color: #525252;
        text-decoration-line: line-through;
    }

    .history-lang__caption {
        margin-bottom: 30px;
        font-size: 18px;
        line-height: 24px;
        color: #56565A;
        font-weight: bold;
    }

    .history-lang__field {
        width: 155px;
        font-size: 15px;
        line-height: 19px;
        color: #858585;
    }

    .history-lang__row {
        margin-bottom: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .history-lang {
        margin-bottom: 40px;
    }

    .history-item__langs {
        padding-left: 65px;
    }

    .history-item__body-wrapper {
        height: 0;
        overflow: hidden;
        transition: .3s;
    }
</style>